/* ARCHER LASER — customizer plug-in.
   Connects the Product Customizer to the shop. This file is the ONLY glue:
   it touches neither the customizer nor the site's own code, it just adds an
   entry point to the shop and hosts the customizer in an overlay.

   The customizer is self-contained — it pulls the live product catalogue from
   the store itself and runs its own picker, cart and Shopify checkout — so the
   plug-in hands it nothing and takes nothing back. It only opens and closes.

   Where the customizer lives:
     window.__CUSTOMIZER_URL__   set by the loader next to this script    */
(function () {
  'use strict';

  var URL_ = window.__CUSTOMIZER_URL__ || '';
  var SRC_JS = window.__CUSTOMIZER_SRC_JS__ || '';
  var INK = '#14181D', RUST = '#B4541F', EDGE = '#D3D2CD',
      MONO = "'IBM Plex Mono',ui-monospace,monospace";
  var wrap = null, frame = null, poll = null, fetching = false;
  /* the piece the visitor was looking at when they clicked, so the tool opens
     on that piece instead of making them pick it again */
  var wanted = null;
  /* kept apart from wanted (which apply() clears once it has chosen): when the
     visitor came in from one piece, the panel shows only that piece */
  var soloPiece = null, soloTimer = null;

  function css() {
    if (document.getElementById('acpCss')) return;
    var s = document.createElement('style');
    s.id = 'acpCss';
    s.textContent = [
      '#acpOverlay{position:fixed;inset:0;z-index:700;background:#fff;',
        'opacity:0;pointer-events:none;transition:opacity .28s ease;}',
      '#acpOverlay.open{opacity:1;pointer-events:auto;}',
      '#acpOverlay iframe{width:100%;height:100%;border:0;display:block;}',
      '#acpClose{position:absolute;top:14px;right:16px;z-index:2;',
        'border:1px solid ' + EDGE + ';background:rgba(255,255,255,.94);color:' + INK + ';',
        'border-radius:980px;padding:9px 16px;font-family:' + MONO + ';font-size:11px;',
        'letter-spacing:.14em;text-transform:uppercase;cursor:pointer;transition:all .2s;',
        'min-height:44px;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);}',
      '#acpClose:hover{border-color:' + INK + ';}',
      /* entry points borrow the shop's own button shapes */
      '.acp-open{border:1px solid ' + INK + ';background:#fff;color:' + INK + ';',
        'border-radius:980px;padding:15px 30px;font-size:15px;font-weight:600;',
        'cursor:pointer;transition:all .2s;font-family:inherit;}',
      '.acp-open:hover{background:' + INK + ';color:#fff;}',
      '.acp-band{display:flex;justify-content:center;margin:0 0 40px;}',
      '.acp-band .acp-open{border-color:' + EDGE + ';color:' + INK + ';}',
      '.acp-band .acp-open:hover{background:' + INK + ';color:#fff;border-color:' + INK + ';}',
      /* the bundle paints its own dark unpack splash while it loads — this
         covers it so the visitor sees the shop's own quiet loading state */
      '#acpLoad{position:absolute;inset:0;z-index:1;display:flex;flex-direction:column;',
        'align-items:center;justify-content:center;gap:18px;background:#FAFAF8;',
        'transition:opacity .3s ease;}',
      '#acpLoad.gone{opacity:0;pointer-events:none;}',
      '#acpLoad p{margin:0;font-family:' + MONO + ';font-size:10.5px;letter-spacing:.16em;',
        'text-transform:uppercase;color:#5D626A;}',
      '#acpSpin{width:26px;height:26px;border:2px solid ' + EDGE + ';border-top-color:' + RUST + ';',
        'border-radius:50%;animation:acpSpin .8s linear infinite;}',
      '@keyframes acpSpin{to{transform:rotate(360deg)}}',
      '#acpFail{position:absolute;inset:0;z-index:2;display:flex;flex-direction:column;',
        'align-items:center;justify-content:center;gap:16px;padding:32px;text-align:center;',
        'background:#FAFAF8;}',
      '#acpFail h2{margin:0;font-family:\'Space Grotesk\',sans-serif;font-size:clamp(22px,3vw,30px);',
        'letter-spacing:-.02em;color:' + INK + ';}',
      '#acpFail p{margin:0;max-width:52ch;font-size:15px;line-height:1.65;color:#4A525C;}',
      '#acpFail .acp-path{font-size:13px;color:#5D626A;}',
      '#acpFail code{font-family:' + MONO + ';font-size:.92em;color:' + RUST + ';}',
      '@media (hover:none){.acp-open{min-height:48px;}#acpClose{padding:12px 18px;}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* Build the overlay and start the bundle unpacking without showing anything.
     Called on hover/touch of an entry button so the click has nothing to wait
     for — the tool is a big self-contained file and unpacks on load. */
  function warm() {
    css();
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'acpOverlay';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.setAttribute('aria-label', 'Design your engraving');
      var x = document.createElement('button');
      x.id = 'acpClose';
      x.type = 'button';
      x.textContent = 'Close';
      x.addEventListener('click', close);
      frame = document.createElement('iframe');
      frame.title = 'Design your engraving';
      frame.setAttribute('allow', 'clipboard-write');
      wrap.appendChild(x);
      wrap.appendChild(frame);
      document.body.appendChild(wrap);
    }
    deliver();
  }

  /* Shopify's asset folder serves only a whitelist of file types, and .html is
     not on it — the customizer file is silently dropped from the theme, which
     is why the overlay sat spinning on the live store. So it travels as a
     script (product-customizer-src.js) holding the page verbatim, and is
     written into the frame here. Writing rather than pointing at a URL also
     keeps the frame same-origin, which is what lets the exit message and the
     quote hand-off work at all. */
  function deliver() {
    if (!frame || frame.__acpFilled) return;
    var html = window.__CUSTOMIZER_HTML__;
    if (typeof html === 'string' && html) {
      frame.__acpFilled = true;
      try {
        var d = frame.contentDocument;
        d.open();
        d.write(PRELUDE + html);
        d.close();
      } catch (err) {
        frame.__acpFilled = false;
        if (URL_) frame.setAttribute('src', URL_);
      }
      return;
    }
    if (fetching) return;
    if (!SRC_JS) { if (URL_) frame.setAttribute('src', URL_); return; }
    fetching = true;
    var s = document.createElement('script');
    s.src = SRC_JS;
    s.onload = function () { fetching = false; deliver(); };
    s.onerror = function () {
      fetching = false;
      /* last resort: the plain file, which works anywhere that serves it */
      if (URL_) frame.setAttribute('src', URL_);
    };
    document.head.appendChild(s);
  }

  /* The customizer designs on the first photo the store returns for a product
     (products.json order). The shop's word: the 1st store photo is the front,
     the 2nd is the back — which is the order the store already returns, so the
     catalogue passes through untouched. The hook stays in place in case the
     order ever needs choosing again (set REORDER to true and pick indexes). */
  var REORDER = false, FRONT_INDEX = 0, BACK_INDEX = 1;
  var PRELUDE = [
    '<script>(function(){',
    'var native = window.fetch;',
    'if (!native || !' + REORDER + ') return;',
    'var FI = ' + FRONT_INDEX + ', BI = ' + BACK_INDEX + ';',
    'window.fetch = function (input, init) {',
    '  var url = typeof input === "string" ? input : (input && input.url) || "";',
    '  var call = native.apply(this, arguments);',
    '  if (url.indexOf("products.json") < 0) return call;',
    '  return call.then(function (res) {',
    '    if (!res || !res.ok) return res;',
    '    return res.clone().json().then(function (data) {',
    '      (data.products || []).forEach(function (p) {',
    '        var im = p.images || [];',
    '        if (im.length < 2) return;',
    '        var front = im[Math.min(FI, im.length - 1)], back = im[Math.min(BI, im.length - 1)];',
    '        p.images = [front, back].concat(im.filter(function (x) {',
    '          return x !== front && x !== back;',
    '        }));',
    '        if (p.images[0] && p.images[0].src) p.featured_image = p.images[0].src;',
    '      });',
    '      return new Response(JSON.stringify(data), {',
    '        status: res.status, statusText: res.statusText, headers: res.headers',
    '      });',
    '    }).catch(function () { return res; });',
    '  });',
    '};',
    '})();<\/script>'
  ].join('');

  function open(piece, workspace) {
    wanted = piece || null;
    soloPiece = wanted;
    /* which panel to land on: Our Product (default) or Your Product */
    if (window.ArcherCustomizerTweaks && window.ArcherCustomizerTweaks.workspace) {
      window.ArcherCustomizerTweaks.workspace(workspace === 'yours' ? 'yours' : 'ours');
    }
    warm();
    typed = [];
    var oldFail = wrap.querySelector('#acpFail');
    if (oldFail) oldFail.remove();
    var cover = wrap.querySelector('#acpLoad');
    if (!cover) {
      cover = document.createElement('div');
      cover.id = 'acpLoad';
      cover.innerHTML = '<div id="acpSpin"></div><p>Opening the design tool</p>';
      wrap.insertBefore(cover, frame);
    }
    frame.style.display = 'block';
    deliver();
    var d = null;
    try { d = frame.contentDocument; } catch (err) {}
    /* never open onto the farewell screen: send it back to the editor first */
    if (d && farewell(d)) rewind(d);
    /* if it is already unpacked from an earlier open, do not flash the cover */
    try { d = frame.contentDocument; } catch (err) {}
    if (!(d && ready(d))) cover.classList.remove('gone');
    document.body.style.overflow = 'hidden';
    /* Opening must not wait on a frame callback: the bundle unpacking in the
       iframe hogs the main thread, and a backgrounded tab stops serving them
       altogether — either way the overlay would stay invisible. Reading layout
       flushes the initial state so the fade still plays. */
    void wrap.offsetWidth;
    wrap.classList.add('open');
    watch();
  }

  function close() {
    if (!wrap) return;
    [].forEach.call(wrap.querySelectorAll('.acp-pin'), function (p) { p.remove(); });
    if (mirror) { mirror.remove(); mirror = null; }
    if (mirrorTimer) { clearInterval(mirrorTimer); mirrorTimer = null; }
    if (soloTimer) { clearInterval(soloTimer); soloTimer = null; }
    wrap.classList.remove('open');
    document.body.style.overflow = '';
    clearInterval(poll);
    /* the frame stays loaded: reopening is then instant, and the visitor's
       work in progress is still there where they left it */
  }

  /* The customizer arrives as a self-contained bundle: it unpacks itself and
     then renders. Ready means the editor is genuinely on screen — not the
     unpack splash, and not a raw unmounted template. Handing over a broken
     page is worse than saying plainly that it didn't load. */
  /* The customizer ends its own exit flow on a farewell screen ("Design
     closed", with a "Reopen the editor" button). Keeping the frame warm means
     the next visitor could open the shop's button straight onto that screen,
     so it is treated as not-ready and rewound before anything is shown. */
  function farewell(d) {
    try {
      return [].filter.call(d.querySelectorAll('h1,h2,h3,p,div,span'), function (e) {
        return !e.children.length && /^design closed$/i.test((e.textContent || '').trim())
          && e.offsetParent !== null;
      })[0] || null;
    } catch (err) { return null; }
  }

  function rewind(d) {
    var back = [].filter.call(d.querySelectorAll('button'), function (b) {
      return /reopen the editor/i.test((b.textContent || '').trim());
    })[0];
    if (back) { back.click(); return true; }
    /* no recovery button — build it afresh */
    frame.__acpFilled = false;
    deliver();
    return false;
  }

  function ready(d) {
    try {
      if (d.querySelector('x-dc')) return false;
      if (farewell(d)) return false;
      var splash = d.getElementById('__bundler_thumbnail');
      if (splash && splash.offsetParent !== null) return false;
      var load = d.getElementById('__bundler_loading');
      if (load && load.offsetParent !== null) return false;
      return (d.body.textContent || '').trim().length > 0;
    } catch (err) { return true; }
  }

  function reveal() {
    var cover = wrap && wrap.querySelector('#acpLoad');
    if (cover) cover.classList.add('gone');
  }

  function fail() {
    reveal();
    if (wrap.querySelector('#acpFail')) return;
    frame.style.display = 'none';
    var box = document.createElement('div');
    box.id = 'acpFail';
    box.innerHTML =
      '<h2>The design tool didn\u2019t load</h2>'
      + '<p>Close this and try again. If it keeps happening, the customizer file '
      + 'may not have uploaded with the theme.</p>'
      + '<p class="acp-path">Loading from: <code>' + String(SRC_JS || URL_) + '</code></p>';
    wrap.appendChild(box);
  }

  function watch() {
    clearInterval(poll);
    var t = 0, rewound = false;
    poll = setInterval(function () {
      if (!wrap || !wrap.classList.contains('open')) return;
      var d;
      try { d = frame.contentDocument; } catch (err) { clearInterval(poll); return; }
      if (!d || !d.body) return;
      /* a load that settles on the farewell screen gets one nudge back to the
         editor rather than being reported as a failure */
      if (farewell(d) && !rewound) { rewound = true; rewind(d); return; }
      /* unpacking takes a moment — give it a fair chance before judging it */
      if (++t < 24) { if (ready(d)) { wire(d); apply(d); trackSolo(d); trackMirror(d); reveal(); clearInterval(poll); } return; }
      clearInterval(poll);
      if (!ready(d)) fail(); else { wire(d); apply(d); trackSolo(d); trackMirror(d); reveal(); }
    }, 500);
  }

  /* "Send for Quote" was wired to a callback the customizer's original host
     supplied, and a standalone copy has no host: it flips its own "request
     sent" line and nothing leaves the page. The plug-in cannot edit the
     customizer, but it can finish the job from outside — take the click and
     carry the design to email, so the confirmation tells the truth. */
  var QUOTE_TO = 'contact@archerlaser.ca';

  /* The design text lives on the Design tab and leaves the DOM when the
     visitor moves to Review, so it is remembered as they type. */
  var typed = [];
  function remember(d) {
    var vals = [].map.call(d.querySelectorAll('textarea, input[type="text"]'), function (i) {
      return (i.value || '').trim();
    }).filter(function (v) {
      return v && !/^\d+$/.test(v) && v.toLowerCase() !== 'type here';
    });
    if (vals.length) typed = vals;
  }

  function summary(d) {
    var out = [], seen = {};
    /* the customizer lists the chosen options as "Label: value" list items */
    var opts = [].filter.call(d.querySelectorAll('li, div, span, p'), function (e) {
      var t = (e.textContent || '').trim();
      return /^[A-Z][A-Za-z ]{2,26}:\s*\S/.test(t) && t.length < 80 && !e.querySelector('li, button, input');
    });
    opts.forEach(function (e) {
      var t = e.textContent.trim();
      if (!seen[t]) { seen[t] = 1; out.push(t); }
    });
    remember(d);
    if (typed.length) out.push('Engraving text: ' + typed.join(' / '));
    var qty = [].filter.call(d.querySelectorAll('input[type="text"]'), function (i) {
      return /^\d+$/.test((i.value || '').trim());
    })[0];
    if (qty) out.push('Quantity: ' + qty.value.trim());
    return out;
  }

  /* The customizer already carries the shop's pieces in its "Our Product"
     panel, so opening on a piece is a matter of choosing it there — the
     customizer is untouched, the plug-in just makes the same choice the
     visitor would have made by hand. */
  function pieces(d) {
    return [].filter.call(d.querySelectorAll('button'), function (b) {
      var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
      return /\$\d/.test(t) && t.length < 90 && !/quote|cart|checkout/i.test(t);
    });
  }

  /* Arriving from a piece — the grid or the product view — means the piece is
     already decided, so the other pieces in the "Our Product" panel are just
     noise to scroll past. They are hidden for that visit (the customizer is
     untouched; this is display state applied at runtime) and come back the
     moment the tool is opened from the shop band with nothing chosen. */
  function solo(d) {
    /* the tweaks file owns the panel's contents when it is present */
    if (window.ArcherCustomizerTweaks && window.ArcherCustomizerTweaks.solo) {
      window.ArcherCustomizerTweaks.solo(soloPiece);
      window.ArcherCustomizerTweaks.apply(d);
      return;
    }
    var all = pieces(d);
    if (!soloPiece) {
      all.forEach(function (b) {
        var card = (b.closest && b.closest('li, [role="listitem"]')) || b;
        if (card.__acpHidden) { card.style.display = card.__acpDisplay || ''; card.__acpHidden = false; }
      });
      return;
    }
    var want = String(soloPiece).replace(/\s+/g, ' ').trim().toLowerCase();
    var keep = all.filter(function (b) {
      return (b.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase().indexOf(want) > -1;
    });
    if (!keep.length) return;
    all.forEach(function (b) {
      var own = (b.closest && b.closest('li, [role="listitem"]')) || b;
      /* the frame is reused between visits, so a piece hidden last time must be
         put back when it is the one chosen this time */
      if (keep.indexOf(b) > -1) {
        if (own.__acpHidden) { own.style.display = own.__acpDisplay || ''; own.__acpHidden = false; }
        return;
      }
      var card = (b.closest && b.closest('li, [role="listitem"]')) || b;
      if (!card.__acpHidden) {
        card.__acpDisplay = card.style.display || '';
        card.__acpHidden = true;
      }
      card.style.display = 'none';
    });
  }

  function trackSolo(d) {
    if (soloTimer) clearInterval(soloTimer);
    solo(d);
    /* the panel mounts and remounts as the visitor moves around the tool */
    soloTimer = setInterval(function () {
      if (!wrap || !wrap.classList.contains('open')) return;
      try { solo(frame.contentDocument); } catch (err) {}
    }, 500);
  }

  function apply(d, tries) {
    if (!wanted) return;
    var want = String(wanted).replace(/\s+/g, ' ').trim().toLowerCase();
    var hit = pieces(d).filter(function (b) {
      var t = (b.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return t.indexOf(want) === 0 || t.indexOf(want) > -1;
    })[0];
    if (hit) {
      /* already the chosen one? leave the visitor's work alone */
      if (!/true/i.test(hit.getAttribute('aria-pressed') || '')) hit.click();
      wanted = null;
      return;
    }
    /* the panel may not be showing yet — open it and look again */
    var tab = [].filter.call(d.querySelectorAll('button'), function (b) {
      return /our product/i.test((b.textContent || '').replace(/\s+/g, ' ').trim());
    })[0];
    if (tab && !tries) tab.click();
    if ((tries || 0) < 8) setTimeout(function () { apply(d, (tries || 0) + 1); }, 180);
    else wanted = null;
  }

  /* ---------- comment pins ----------
     Review comments attach to elements in this page, and the design tool lives
     in its own frame — so the controls inside it cannot be pinned, only the
     frame as a whole. The frame is same-origin, so the plug-in can project a
     target back out: Option-click (Alt-click) anything inside the tool and a
     real, pinnable element appears in the page over that exact spot, named
     after the control. Click a pin to remove it. Nothing appears unless it is
     asked for, and it is off on the live store — this is a review aid. */
  function pinsAllowed() {
    if (/[?&]pins=0/.test(location.search)) return false;
    if (/[?&]pins=1/.test(location.search)) return true;
    /* the published store stays clean; previews get it */
    return !/(^|\.)archerlaser\.(ca|com)$|myshopify\.com$/i.test(location.hostname);
  }

  var pinSeq = 0;

  function label(el) {
    var t = (el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('title'))) || '';
    if (!t) t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t && el.tagName === 'INPUT') t = el.getAttribute('placeholder') || 'input';
    if (!t) t = (el.tagName || 'element').toLowerCase();
    return t.slice(0, 46);
  }

  function pin(el, e) {
    var r = el.getBoundingClientRect(), f = frame.getBoundingClientRect();
    var name = label(el);
    var box = document.createElement('div');
    box.className = 'acp-pin';
    box.setAttribute('data-comment-anchor', 'acp-pin-' + (++pinSeq));
    box.setAttribute('data-acp-control', name);
    box.setAttribute('role', 'note');
    box.setAttribute('aria-label', 'Comment target: ' + name);
    box.style.cssText = 'position:fixed;z-index:760;box-sizing:border-box;'
      + 'border:2px dashed ' + RUST + ';border-radius:6px;background:rgba(180,84,31,.10);'
      + 'cursor:pointer;'
      + 'left:' + Math.round(f.left + r.left) + 'px;'
      + 'top:' + Math.round(f.top + r.top) + 'px;'
      + 'width:' + Math.max(12, Math.round(r.width)) + 'px;'
      + 'height:' + Math.max(12, Math.round(r.height)) + 'px;';
    var tag = document.createElement('span');
    tag.textContent = name;
    tag.style.cssText = 'position:absolute;left:0;top:100%;margin-top:3px;white-space:nowrap;'
      + 'background:' + INK + ';color:#fff;border-radius:4px;padding:3px 7px;'
      + 'font:500 10px/1.2 ' + MONO + ';letter-spacing:.06em;text-transform:uppercase;';
    box.appendChild(tag);
    box.addEventListener('click', function (ev) { ev.stopPropagation(); box.remove(); });
    wrap.appendChild(box);
    if (e) { e.preventDefault(); e.stopPropagation(); }
  }

  /* Review mode captures the mouse before the frame ever sees it, so
     Option-click cannot fire while commenting and hovering only ever finds the
     frame as a whole. With ?pins=all the plug-in instead lays a mirror of the
     tool's controls into the host page: one transparent, named element per
     control, sitting exactly over it. Hovering then picks out that control by
     name, and a click on a mirror is passed straight through to the real
     control underneath, so the tool still works while the mirror is up.
     The design stage is deliberately not mirrored — dragging artwork must
     reach the tool untouched. */
  var mirror = null, mirrorTimer = null;

  function mirrorOn() {
    if (/[?&]pins=0/.test(location.search)) return false;
    if (/[?&]pins=all/.test(location.search)) return true;
    return pinsAllowed();
  }

  function forward(el) {
    return function (ev) {
      ev.stopPropagation();
      try {
        var tag = (el.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || tag === 'select') el.focus();
        el.click();
      } catch (err) {}
    };
  }

  function buildMirror(d) {
    if (!mirrorOn() || !wrap || !frame) return;
    if (!mirror) {
      mirror = document.createElement('div');
      mirror.className = 'acp-mirror';
      mirror.style.cssText = 'position:fixed;inset:0;z-index:755;pointer-events:none;';
      wrap.appendChild(mirror);
    }
    var f = frame.getBoundingClientRect();
    var keep = {};
    var list = d.querySelectorAll('button, [role="button"], label, input, textarea, select, a');
    [].forEach.call(list, function (el, i) {
      if (el.type === 'range' || el.getAttribute('draggable') === 'true') return;
      var r = el.getBoundingClientRect();
      if (r.width < 8 || r.height < 8) return;
      if (r.bottom < 0 || r.top > f.height) return;
      var id = 'acp-c' + i;
      keep[id] = 1;
      var box = mirror.querySelector('[data-acp-id="' + id + '"]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-acp-id', id);
        box.setAttribute('data-comment-anchor', id);
        box.style.cssText = 'position:fixed;box-sizing:border-box;pointer-events:auto;'
          + 'border:1px solid transparent;border-radius:6px;';
        box.addEventListener('mouseenter', function () {
          box.style.borderColor = RUST;
          box.style.background = 'rgba(180,84,31,.08)';
        });
        box.addEventListener('mouseleave', function () {
          box.style.borderColor = 'transparent';
          box.style.background = 'transparent';
        });
        box.addEventListener('click', forward(el));
        mirror.appendChild(box);
      }
      var name = label(el);
      box.setAttribute('aria-label', name);
      box.setAttribute('title', name);
      box.setAttribute('data-acp-control', name);
      box.style.left = Math.round(f.left + r.left) + 'px';
      box.style.top = Math.round(f.top + r.top) + 'px';
      box.style.width = Math.round(r.width) + 'px';
      box.style.height = Math.round(r.height) + 'px';
    });
    [].forEach.call(mirror.children, function (box) {
      if (!keep[box.getAttribute('data-acp-id')]) box.remove();
    });
  }

  function trackMirror(d) {
    if (!mirrorOn() || mirrorTimer) return;
    buildMirror(d);
    /* the tool's panels open and close, so positions are refreshed */
    mirrorTimer = setInterval(function () {
      if (!wrap || !wrap.classList.contains('open')) return;
      try { buildMirror(frame.contentDocument); } catch (err) {}
    }, 600);
    addEventListener('resize', function () {
      try { buildMirror(frame.contentDocument); } catch (err) {}
    });
  }

  function pinnable(d) {
    if (!pinsAllowed() || d.__acpPins) return;
    d.__acpPins = true;
    d.addEventListener('click', function (e) {
      if (!e.altKey) return;
      var el = e.target;
      if (!el || el.nodeType !== 1) return;
      /* prefer the control the visitor means, not the glyph inside it */
      var ctl = el.closest && el.closest('button, [role="button"], label, input, textarea, select, a');
      pin(ctl || el, e);
    }, true);
  }

  function wire(d) {
    if (d.__acpWired) return;
    d.__acpWired = true;
    pinnable(d);
    /* interface changes asked for after the fact live in customizer-tweaks.js,
       so the customizer's own file is never edited */
    if (window.ArcherCustomizerTweaks) window.ArcherCustomizerTweaks.watch(d);
    d.addEventListener('input', function () { remember(d); }, true);
    remember(d);
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('button');
      if (!b || !/send for quote/i.test((b.textContent || '').trim())) return;
      var lines = summary(d);
      var body = 'Hi Archer Laser,\n\nI\u2019d like a quote for this design:\n\n'
        + (lines.length ? lines.join('\n') : '(see attached mockup)')
        + '\n\nI\u2019ll attach the mockup PNG from the design tool.\n\nThanks,';
      var href = 'mailto:' + QUOTE_TO
        + '?subject=' + encodeURIComponent('Quote request — engraved piece')
        + '&body=' + encodeURIComponent(body);
      try { window.open(href, '_self'); } catch (err) { location.href = href; }
    }, true);
  }

  function button(label, cls, piece) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'acp-open' + (cls ? ' ' + cls : '');
    b.textContent = label;
    b.addEventListener('pointerenter', warm);
    b.addEventListener('touchstart', warm, { passive: true });
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open(typeof piece === 'function' ? piece() : piece);
    });
    return b;
  }

  /* Two ways in, both inside the shop: one under the grid for browsing, and
     one beside Add to cart for a piece already in view. */
  function mount() {
    css();
    var band = document.querySelector('.shop-band .wrap');
    var note = band && band.querySelector('.shop-note');
    if (band && note && !band.querySelector('.acp-band')) {
      var row = document.createElement('div');
      row.className = 'acp-band';
      row.appendChild(button('Design your engraving'));
      band.insertBefore(row, note);
    }
    var buy = document.querySelector('.pview .pv-buy');
    if (buy && !buy.querySelector('.acp-open')) {
      /* read the name at click time — one product view serves every piece */
      buy.appendChild(button('Engrave it', '', function () {
        var n = document.getElementById('pvName');
        return n ? (n.textContent || '').trim() : null;
      }));
    }
    /* the hero's "Bring us your own piece" opens the tool on Your Product —
       the link stays exactly as it is; only where it goes changes */
    var own = [].filter.call(document.querySelectorAll('.hero-ctas a'), function (a) {
      return /your own piece/i.test(a.textContent || '');
    })[0];
    if (own && !own.__acpWired) {
      own.__acpWired = true;
      own.addEventListener('pointerenter', warm);
      own.addEventListener('touchstart', warm, { passive: true });
      own.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open(null, 'yours');
      });
    }
  }

  /* The customizer announces its own exit — its "Save & Exit" flow ends with
     a customizer-exit message — so finishing inside the editor closes the
     overlay too, instead of stranding the visitor on its farewell screen. */
  addEventListener('message', function (e) {
    if (!wrap || !frame) return;
    if (e.source !== frame.contentWindow && e.source !== window) return;
    var d = e.data;
    if (d && d.type === 'customizer-exit') { close(); var pvw = document.getElementById('pview'), pvc = document.getElementById('pvClose'); if (pvw && pvw.classList.contains('open') && pvc) pvc.click(); }
  });

  addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrap && wrap.classList.contains('open')) close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else mount();
  /* the shop grid and product view are built by the site's own script, so keep
     looking until they exist */
  var tries = 0;
  var wait = setInterval(function () { mount(); if (++tries > 40) clearInterval(wait); }, 300);

  window.ArcherCustomizer = { open: open, close: close };
})();
